var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback, useMemo, useState } from 'react';
import { useBlocker, useLoaderData, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useAtomValue, useSetAtom } from 'jotai';

import { isEmpty } from 'lodash';
import { Translate } from "../../../../I18N";

import { SettingsContent } from "../../../Components/Layouts/SettingsContent";
import { Button } from "../../../Components/UI";
import { ConfirmNavigationModal } from "../../../Components/Forms";
import { notificationAtom, templatesAtom } from "../../../atoms";


import {
  addGroupSubmit,
  addItemSubmit,
  compareThesaurus,
  emptyThesaurus,
  removeItem,
  sanitizeThesaurusValues,
  sortValues,
  thesaurusAsRow } from "./helpers";


import { DeletionModal, GroupForm, ThesaurusValueForm, ThesaurusActions } from "./components";

import { ThesaurusForm } from "./ThesaurusForm";
import { ImportButton } from "./components/ImportButton";

const EditThesaurus = () => {
  const navigate = useNavigate();
  const thesaurus = useLoaderData();
  const templates = useAtomValue(templatesAtom);
  const [showNavigationModal, setShowNavigationModal] = useState(false);
  const [groupFormValues, setGroupFormValues] = useState();
  const [itemFormValues, setItemFormValues] = useState([]);
  const [showThesauriValueFormSidepanel, setShowThesauriValueFormSidepanel] = useState(false);
  const [showThesauriGroupFormSidepanel, setShowThesauriGroupFormSidepanel] = useState(false);
  const [selectedThesaurusValue, setSelectedThesaurusValue] = useState([]);
  const [thesaurusValues, setThesaurusValues] = useState([]);
  const [warnAboutUse, setWarnAboutUse] = useState(false);
  const [isImporting, setIsImporting] = useState(false);
  const [confirmCallback, setConfirmCallback] = useState();
  const setNotifications = useSetAtom(notificationAtom);

  useMemo(() => {
    const currentThesaurus = thesaurus || { values: [] };
    setWarnAboutUse(
      templates.find((t) =>
      (t.properties || []).some(
        (property) => property.content === currentThesaurus._id
      )
      ) !== undefined
    );
    setThesaurusValues(currentThesaurus.values.map(thesaurusAsRow));
  }, [templates, thesaurus]);

  const form = useForm({ defaultValues: thesaurus, mode: 'onSubmit' });
  const { watch, getValues, setValue } = form;

  const getCurrentStatus = useCallback(
    () => _objectSpread(_objectSpread({}, getValues()), {}, { values: sanitizeThesaurusValues(thesaurusValues) }),
    [getValues, thesaurusValues]
  );

  const checkPendingChanges = useCallback(
    (nextLocation) =>
    !(nextLocation !== null && nextLocation !== void 0 && nextLocation.pathname.includes('edit')) && compareThesaurus(thesaurus, getCurrentStatus()),
    [getCurrentStatus, thesaurus]
  );

  const blocker = useBlocker(({ nextLocation }) => checkPendingChanges(nextLocation));

  useMemo(() => {
    if (blocker.state === 'blocked') {
      setShowNavigationModal(true);
    }
  }, [blocker, setShowNavigationModal]);

  const addItem = () => {
    setItemFormValues([]);
    setShowThesauriValueFormSidepanel(true);
  };
  const addGroup = () => {
    setGroupFormValues(emptyThesaurus());
    setShowThesauriGroupFormSidepanel(true);
  };
  const editGroup = (row) => {
    setGroupFormValues(row.original);
    setShowThesauriGroupFormSidepanel(true);
  };
  const editValue = (row) => {var _row$getParentRow;
    setItemFormValues([_objectSpread(_objectSpread({}, row.original), {}, { groupId: (_row$getParentRow = row.getParentRow()) === null || _row$getParentRow === void 0 ? void 0 : _row$getParentRow.original.rowId })]);
    setShowThesauriValueFormSidepanel(true);
  };

  const edit = (row) => row.original.subRows ? editGroup(row) : editValue(row);

  const proceedDeletion = () => {
    setThesaurusValues((prev) => {
      selectedThesaurusValue.forEach((deletedItem) => {
        removeItem(prev, deletedItem);
      });
      return [...prev];
    });
  };
  const deleteSelected = () => {
    if (!warnAboutUse || !selectedThesaurusValue[0].id) {
      proceedDeletion();
    } else {
      setConfirmCallback({ callback: proceedDeletion });
    }
  };

  return (/*#__PURE__*/
    _jsx("div", {
      className: "tw-content",
      style: { width: '100%', overflowY: 'auto' },
      "data-testid": "settings-thesauri" }, void 0, /*#__PURE__*/

    _jsx(SettingsContent, { className: "flex flex-col h-full" }, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, {
      path: new Map([['Thesauri', '/settings/thesauri']]),
      title: watch('name') }
    ), /*#__PURE__*/
    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx(ThesaurusForm, {
      thesaurus: thesaurus,
      edit: edit,
      form: form,
      thesaurusValues: thesaurusValues,
      setThesaurusValues: setThesaurusValues,
      setSelectedThesaurusValue: setSelectedThesaurusValue }
    )
    ), /*#__PURE__*/
    _jsx(SettingsContent.Footer, { className: "bottom-0 bg-indigo-50" }, void 0,
    !isEmpty(selectedThesaurusValue) && /*#__PURE__*/
    _jsx("div", { className: "flex items-center gap-2" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      type: "button",
      onClick: deleteSelected,
      color: "error",
      "data-testid": "thesauri-remove-button" }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Remove")
    ), /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Selected"), " ", selectedThesaurusValue.length, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "of"), " ", thesaurusValues.length
    ),

    selectedThesaurusValue.length === 0 && /*#__PURE__*/
    _jsx("div", { className: "flex justify-between w-full" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0, /*#__PURE__*/
    _jsx(Button, { onClick: addItem }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Add item")
    ), /*#__PURE__*/
    _jsx(Button, { styling: "light", onClick: addGroup }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Add group")
    ), /*#__PURE__*/
    _jsx(Button, { styling: "light", onClick: sortValues(thesaurusValues, setThesaurusValues) }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Sort")
    ), /*#__PURE__*/
    _jsx(ImportButton, {
      onClick: () => {
        setIsImporting(true);
      },
      disabled: isEmpty(getValues().name),
      getThesaurus: getCurrentStatus,
      onSuccess: (savedThesaurus) => {
        setValue('_id', savedThesaurus._id);
        setNotifications({
          type: 'success',
          text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Thesauri updated.")
        });
        navigate(`../edit/${savedThesaurus._id}`);
        setIsImporting(false);
      },
      onFailure: () => {
        setIsImporting(false);
        setNotifications({
          type: 'error',
          text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Error adding thesauri.")
        });
      } }
    )
    ), /*#__PURE__*/
    _jsx(ThesaurusActions, { disabled: isImporting })
    )

    )
    ), /*#__PURE__*/
    _jsx(ThesaurusValueForm, {
      showSidepanel: showThesauriValueFormSidepanel,
      submit: addItemSubmit(thesaurusValues, setThesaurusValues),
      value: itemFormValues,
      closePanel: () => {
        setShowThesauriValueFormSidepanel(false);
      },
      thesaurusValues: thesaurusValues }
    ), /*#__PURE__*/
    _jsx(GroupForm, {
      showSidepanel: showThesauriGroupFormSidepanel,
      submit: addGroupSubmit(thesaurusValues, setThesaurusValues),
      value: groupFormValues,
      closePanel: () => {
        setShowThesauriGroupFormSidepanel(false);
      } }
    ),
    showNavigationModal && /*#__PURE__*/
    _jsx(ConfirmNavigationModal, { setShowModal: setShowNavigationModal, onConfirm: blocker.proceed }),

    confirmCallback !== undefined && /*#__PURE__*/
    _jsx(DeletionModal, { confirmCallback: confirmCallback, setConfirmCallback: setConfirmCallback })

    ));

};
export { EditThesaurus };